// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"SubscriptionCustomers_headerContainer__2jE4M"};